import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import useLegacySeoMeta from '~/composables/useLegacySeoMeta';
import { useGetTranslations } from '~/composables/useGetTranslations';
import { formatHeaderItemsGraphql } from '~/helpers/formatHeaderItemGraphql';
import { useTrpc } from '~/composables/_next/useTrpc';
import NuxtLinkCustom from '~/components/_next/molecules/NuxtLinkCustom.vue';
import AzBackToTopButton from '~/components/_next/atoms/AzBackToTopButton';
import { useDynamicYield } from '~/composables/_next/useDynamicYield';
import { useLocalization } from '~/composables/_next/useLocalization';
export default defineComponent({
  name: 'AllProducts',
  components: {
    MenuSubcategoryList: function MenuSubcategoryList() {
      return import('~/components/Layout/Menu/components/MenuSubcategoryList.vue');
    },
    AppCategoriesHeader: function AppCategoriesHeader() {
      return import('~/components/Layout/AppCategoriesHeader.vue');
    },
    AzBackToTopButton: AzBackToTopButton,
    NuxtLinkCustom: NuxtLinkCustom
  },
  setup: function setup() {
    var route = useRoute();
    var _useNuxt2App = useNuxt2App(),
      error = _useNuxt2App.error,
      app = _useNuxt2App.app;
    var _useLocalization = useLocalization(),
      locale = _useLocalization.locale;
    var _useDynamicYield = useDynamicYield(true),
      setDynamicYieldContext = _useDynamicYield.setDynamicYieldContext,
      setDynamicYieldContextSSR = _useDynamicYield.setDynamicYieldContextSSR;
    var _useLegacySeoMeta = useLegacySeoMeta(),
      setMeta = _useLegacySeoMeta.setMeta,
      getMeta = _useLegacySeoMeta.getMeta;
    var _useTrpc = useTrpc(),
      client = _useTrpc.client;
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var _useSlug = useSlug(),
      transformSlugsForSeo = _useSlug.transformSlugsForSeo;
    var headerItems = useState('products-header-items', function () {
      return null;
    });
    var contentfulResponse = useState('products-content', function () {
      return null;
    });
    provide('content', false);
    var pageAllProductCollection = computed(function () {
      var _contentfulResponse$v, _contentfulResponse$v2;
      return ((_contentfulResponse$v = contentfulResponse.value) === null || _contentfulResponse$v === void 0 ? void 0 : (_contentfulResponse$v2 = _contentfulResponse$v.data) === null || _contentfulResponse$v2 === void 0 ? void 0 : _contentfulResponse$v2.pageAllProductCollection) || null;
    });
    var headerTitle = computed(function () {
      var _pageAllProductCollec, _pageAllProductCollec2, _pageAllProductCollec3;
      return ((_pageAllProductCollec = pageAllProductCollection.value) === null || _pageAllProductCollec === void 0 ? void 0 : (_pageAllProductCollec2 = _pageAllProductCollec.items) === null || _pageAllProductCollec2 === void 0 ? void 0 : (_pageAllProductCollec3 = _pageAllProductCollec2[0]) === null || _pageAllProductCollec3 === void 0 ? void 0 : _pageAllProductCollec3.title) || '';
    });
    var categorySlug = computed(function () {
      var _pageAllProductCollec4, _pageAllProductCollec5, _pageAllProductCollec6;
      return ((_pageAllProductCollec4 = pageAllProductCollection.value) === null || _pageAllProductCollec4 === void 0 ? void 0 : (_pageAllProductCollec5 = _pageAllProductCollec4.items) === null || _pageAllProductCollec5 === void 0 ? void 0 : (_pageAllProductCollec6 = _pageAllProductCollec5[0]) === null || _pageAllProductCollec6 === void 0 ? void 0 : _pageAllProductCollec6.slug) || '';
    });
    var breadcrumbs = computed(function () {
      return [{
        link: app.localePath({
          name: 'index'
        }),
        text: translate('utils.homeBreadcrumbs')
      }, {
        link: app.localePath("/".concat(categorySlug.value)),
        text: headerTitle.value
      }];
    });
    var bannerBackgroundImage = computed(function () {
      var _pageAllProductCollec7, _pageAllProductCollec8, _pageAllProductCollec9, _pageAllProductCollec0;
      return ((_pageAllProductCollec7 = pageAllProductCollection.value) === null || _pageAllProductCollec7 === void 0 ? void 0 : (_pageAllProductCollec8 = _pageAllProductCollec7.items) === null || _pageAllProductCollec8 === void 0 ? void 0 : (_pageAllProductCollec9 = _pageAllProductCollec8[0]) === null || _pageAllProductCollec9 === void 0 ? void 0 : (_pageAllProductCollec0 = _pageAllProductCollec9.bannerBackgroundImage) === null || _pageAllProductCollec0 === void 0 ? void 0 : _pageAllProductCollec0.url) || null;
    });
    useLazyAsyncData('page-allProducts', /*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _route$path$split, _route$path$split$sli, _pageAllProductCollec1, _pageAllProductCollec10, _pageAllProductCollec11, _pageAllProductCollec12, _pageAllProductCollec13, _pageAllProductCollec14, _contentfulResponse$v3, _contentfulResponse$v4, _contentfulResponse$v5, _contentfulResponse$v6, _contentfulResponse$v7, _contentfulResponse$v8;
      var routeSlug, seoFallback, seo, itemsRaw;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            routeSlug = (_route$path$split = route.path.split('/')) === null || _route$path$split === void 0 ? void 0 : (_route$path$split$sli = _route$path$split.slice(-1)) === null || _route$path$split$sli === void 0 ? void 0 : _route$path$split$sli[0];
            _context.next = 3;
            return client.contentful.getAllProductsPage.query({
              locale: locale,
              slug: routeSlug
            });
          case 3:
            contentfulResponse.value = _context.sent;
            seoFallback = {
              title: headerTitle.value
            };
            seo = Object.assign({}, seoFallback, (_pageAllProductCollec1 = pageAllProductCollection.value) === null || _pageAllProductCollec1 === void 0 ? void 0 : (_pageAllProductCollec10 = _pageAllProductCollec1.items) === null || _pageAllProductCollec10 === void 0 ? void 0 : (_pageAllProductCollec11 = _pageAllProductCollec10[0]) === null || _pageAllProductCollec11 === void 0 ? void 0 : _pageAllProductCollec11.seo, {
              slug: transformSlugsForSeo((_pageAllProductCollec12 = pageAllProductCollection.value) === null || _pageAllProductCollec12 === void 0 ? void 0 : _pageAllProductCollec12.items[0])
            });
            setMeta(seo);
            if (!((_pageAllProductCollec13 = pageAllProductCollection.value) !== null && _pageAllProductCollec13 !== void 0 && (_pageAllProductCollec14 = _pageAllProductCollec13.items) !== null && _pageAllProductCollec14 !== void 0 && _pageAllProductCollec14[0])) {
              error({
                statusCode: 404
              });
            }
            itemsRaw = ((_contentfulResponse$v3 = contentfulResponse.value) === null || _contentfulResponse$v3 === void 0 ? void 0 : (_contentfulResponse$v4 = _contentfulResponse$v3.data) === null || _contentfulResponse$v4 === void 0 ? void 0 : (_contentfulResponse$v5 = _contentfulResponse$v4.pageAllProductCollection) === null || _contentfulResponse$v5 === void 0 ? void 0 : (_contentfulResponse$v6 = _contentfulResponse$v5.items) === null || _contentfulResponse$v6 === void 0 ? void 0 : (_contentfulResponse$v7 = _contentfulResponse$v6[0]) === null || _contentfulResponse$v7 === void 0 ? void 0 : (_contentfulResponse$v8 = _contentfulResponse$v7.itemsCollection) === null || _contentfulResponse$v8 === void 0 ? void 0 : _contentfulResponse$v8.items) || null;
            if (itemsRaw && itemsRaw.length > 0) {
              headerItems.value = formatHeaderItemsGraphql(itemsRaw);
            }
            return _context.abrupt("return", true);
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee);
    })));
    onMounted(function () {
      window.scrollTo(0, 0);
      setDynamicYieldContext('OTHER', ['All_Product_Page']);
    });
    setDynamicYieldContextSSR('OTHER', ['All_Product_Page']);
    return {
      getMeta: getMeta,
      breadcrumbs: breadcrumbs,
      bannerBackgroundImage: bannerBackgroundImage,
      headerItems: headerItems,
      headerTitle: headerTitle
    };
  }
});